import React, { useEffect } from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import IconSelect from "./IconSelect";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette,{fontColorAssociations} from "./PMGColorPalette";

import {PanelBody,Panel,RangeControl,SelectControl,CheckboxControl,TextareaControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

const generateUniqueId = () => {
  return 'block-' + Date.now() + '-' + Math.floor(Math.random() * 100);
};

registerBlockType("template-scripts/team-bio",{
  "title":"Biography Popup",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    fullname:{type:'string',default:''},
    jobtitle:{type:'string',default:''},
    photo:{type:'object',default:{}},
    bio:{type:'string',default:''},
    uniqueid:{type:'string',default:''}
  },

  edit:function({attributes,setAttributes}){

    useEffect(()=>{
      if(!attributes.uniqueid || attributes.uniqueid == ""){
        setAttributes({uniqueid:generateUniqueId()});
      }
    },[]);
    return (<div>

      <BlockControls/>
      <InspectorControls>
        <Panel>
          <PanelBody title="Biography">
            <TextareaControl
              rows={20}
              value={attributes.bio}
              onChange={(v)=>setAttributes({bio:v})}
              label="Full Biography"
            />
          </PanelBody>
        </Panel>
      </InspectorControls>
      <div className="teamBio">
          <div style={{position:"relative",height:"160px"}}>
            <img src={attributes.photo.url} className="headshot"/>
            <div style={{display:"flex",position:"absolute",width:"100%",height:"100%",justifyContent:"center",alignItems:"center",top:"0px",left:"0px"}}>
              <MediaUpload
                  value={attributes.photo}
                  onSelect={(v)=>setAttributes({photo:v})}
                  render={({open})=>(
                      <Button
                        className={`editor-post-featured-image__toggle`}
                        onClick={open}
                        style={{width:"120px"}}
                      >
                        Change Photo
                      </Button>
                    )}
              />                    
            </div>
          </div>
          <RichText tagName="h3" placeholder="Name" value={attributes.fullname} onChange={(v)=>setAttributes({fullname:v})}/>
          <RichText tagName="h4" placeholder="Title" value={attributes.jobtitle} onChange={(v)=>setAttributes({jobtitle:v})}/>
          <a>View Bio</a> (Type Bio in Right Panel)
      </div>
    </div>);
  },
  save:function({attributes}){

    return (<>

      <div className="teamBio">
          <img src={attributes.photo?.url} className="headshot"/>
   
          <RichText.Content tagName="h3" value={attributes.fullname}/>
          <RichText.Content tagName="h4" value={attributes.jobtitle}/>
          <a href="#" data-showPopup={attributes.uniqueid}>View Bio</a>
      </div>

      <div className="teamBioPopup" data-popupid={attributes.uniqueid}>
          <div className="popupClose iconClose">&times;</div>
          <div className="popupContent">
            <div className="teamBio">
                <img src={attributes.photo?.url} className="headshot"/>
        
                <RichText.Content style={{textAlign:"center"}} tagName="h3" value={attributes.fullname}/>
                <RichText.Content style={{textAlign:"center"}} tagName="h4" value={attributes.jobtitle}/>
            </div>
            <p dangerouslySetInnerHTML={{__html:attributes.bio.replace(/\n/g,"<br/>")}}></p>
            <a href="#" className="popupClose textClose">&times; Close</a>
          </div>
      </div>
    </>);
  }
});

